import React from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import { Modal, Text } from "@familyzone/component-library";

class DeleteModal extends React.Component {
  handleHide = () => {
    this.props.handleClose();
  };

  handle_Delete = () => {
    this.props.onDelete();
  };

  render() {
    if (this.props.visible) {
      return (
        <Modal
          headerText={"Confirm Delete?"}
          size="md"
          variant="danger"
          isOpen={this.props.visible}
          onClose={this.handleHide}
          primaryCTALabel={"Delete"}
          onPrimaryCTAClick={this.handle_Delete}
          secondaryCTALabel={"Cancel"}
          onSecondaryCTAClick={this.handleHide}
        >
          <Text mt="sp16">Are you sure you wish to delete this object?</Text>
        </Modal>
      );
    }

    return [];
  }
}

export default class DeleteButton extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      delete_confirm: false,
    };
  }

  onConfirm = () => {
    this.setState({
      delete_confirm: true,
    });
  };

  onDelete = () => {
    if (this.props.to !== undefined) {
      this.context.router.push(this.props.to);
    }
    this.setState({ delete_confirm: false });
    this.props.onClick();
  };

  onCancel = () => {
    this.setState({
      delete_confirm: false,
    });
  };

  render() {
    return (
      <Link
        onClick={this.onConfirm}
        data-testid="delete-button"
        aria-label="Delete"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            this.onConfirm();
          }
        }}
      >
        <div>
          <DeleteModal visible={this.state.delete_confirm} onDelete={this.onDelete} handleClose={this.onCancel} />
        </div>
        {this.props.isDeleting ? <i className="fa fa-refresh fa-spin fa-fw" /> : <i className="fa fa-trash" />}
      </Link>
    );
  }
}

DeleteButton.contextTypes = {
  router: PropTypes.object.isRequired,
};
